import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedOvw202601: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_ovw_202601",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-01-01",
  endDate: "2026-01-31",
  impressions: 44264,
  clicks: 897,
  adsSpendDollars: 2471,
  budgetDollars: 4900,
  salesDollars: 15626,
  bestEstimateRoas: 6.32,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.5,
  newCustomersAcquired: 42,
  reorderConversions: 20,
  dataAvailableAtDate: "2026-02-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
